import BaseObject from '../../../base/base_object';
import {KEY_NAME} from './native_const';
import _ from '../../../utils/underscore'; // eslint-disable-line id-length


/**
 * The Native is responsible to sent the message to the correct hybrid(IOS,Android)
 * The Native create a unique temporary function on the main window(to save the context of the calback function).
 * The Native will delete the temporary function after he call it.
 */
class Native extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'Native';


    /**
     * @property
     * @type {int}
     * @private
     */
    _idd = 0;

    _parent = null;


    /**
     * Get the  function Id
     *
     * @returns {int} - Returns the next(unique) id
     */
    getID() {
        this._idd++;

        return 'hybridCallback' + this._idd;
    }

    /**
     * Entry point to recive calls from hybrid.
     *
     * @param parent: the HybridService;
     * @param params: parameters in json format.
     */
    initHybridDirectCall(parent) {
      this._parent = parent;
        window[KEY_NAME.HYBRID_CB_GLOBAL_NAME] = (params) => {
            params = this.getParams(params);
            this._parent.onHybridDirectCall(params);
        };
    }

    /**
     * Entry point to send calls for hybrid & back.
     *
     * @param serviceFuncName: the service name + function name for exp: WebView_Webshow:
     * WebView - service name.
     * WebShow - function name.
     * @param jsonParams: parameters in json format.
     * @returns {Promise}
     */
    msgToHybrid(serviceFuncName, jsonParams = {}) {
        return new Promise((resolve) => {
            let autoGeneratedCBID = this.getID();
            this.logger.info([
                'Hybrid Call:',
                'Request ID: ' + autoGeneratedCBID,
                'Method: ' + serviceFuncName,
                'Params: ' + JSON.stringify(jsonParams)
            ]);
            window[autoGeneratedCBID] = function(id, callback, self, serviceName) {
                return params => {
                    params = self.getParams(params);
                    let allParams = _.safeJSONandDecode(params);
                    self.logger.info([
                        'Hybrid Response:',
                        'Request ID: ' + id,
                        'Service: ' + serviceName,
                        'Params: ' + allParams,
                        'Error: ' + allParams[KEY_NAME.ERROR]
                    ]);
                    callback(params);
                    delete window[id];
                };
            }(autoGeneratedCBID, resolve, this, serviceFuncName);

            let extractFunctionName = this._extractFunctionConvenstion(serviceFuncName),
                payloadForHybrid = Object.assign({}, jsonParams, {
                    [KEY_NAME.SRV]: extractFunctionName.service,
                    [KEY_NAME.FUNC]: extractFunctionName.method,
                    [KEY_NAME.FUNC_CB]: autoGeneratedCBID
                });
            this.callToHandler(payloadForHybrid);
        });
    }

    /**
     * Converts string name into a convention call. String input example: WEBVIEW_INIT
     * In this case Class is: WEBVIEW and method is INIT.
     *
     * @param {String} serviceFuncName - underscore seperated string
     * @returns {Object} - {service: {*}, method: {*}}
     * @private
     */
    _extractFunctionConvenstion(serviceFuncName) {
        let extractFunctionName = serviceFuncName.split('_');

        return {
            service: extractFunctionName[0],
            method: extractFunctionName[1]
        };
    }

    callToHandler() {
    }
    getParams(params) {
        return '';
    }
}

export default Native;


